/* eslint-disable react/prop-types */ // TODO: add props
import cx from 'classnames';
import { SafeHTML } from 'edrolo/domains/app';
import { getOptionLabelFromIndex } from '../../utils';
import s from './styles.scss';
import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';

const CHECKED_LARGE_SRC = `${global.__static__}img/exam-master/checked-large.png`;
const CHECKED_LARGE_2X_SRC = `${global.__static__}img/exam-master/checked-large@2x.png`;
const CORRECT_SRC = `${global.__static__}img/exam-master/correct.png`;
const CORRECT_2X_SRC = `${global.__static__}img/exam-master/correct@2x.png`;
const MISTAKE_LARGE_SRC = `${global.__static__}img/exam-master/mistake-large.png`;
const MISTAKE_LARGE_2X_SRC = `${global.__static__}img/exam-master/mistake-large@2x.png`;

export const MultiSelector = ({
  answers,
  correctAnswers,
  selectedAnswerIds,
  onChange,
  isCorrect,
  disabled,
}) => {
  const isCorrectAnswer = (answerId) =>
    correctAnswers && correctAnswers.indexOf(answerId) > -1;
  const isIncorrectAnswer = (answerId) =>
    correctAnswers && correctAnswers.indexOf(answerId) === -1;

  return (
    <>
      <ul
        className={cx(s.options, { [s.disabled]: disabled })}
        data-test={`${disabled ? 'answer' : 'question'}-${
          EXAM_QUESTION_TYPES.SELECT_MULTI
        }`}
      >
        {answers.map((answer, index) => {
          const answerId = answer.get('id');
          const correct = isCorrectAnswer(answerId);
          const incorrect = isIncorrectAnswer(answerId);
          const selected = selectedAnswerIds?.some(
            (selectedAnswerId) => selectedAnswerId === answerId
          );

          // Questions with more than 26 options will not show labels
          const optionLabel = getOptionLabelFromIndex(index);

          let checkmarkSrc = null;
          let checkmarkSrcSet;
          if (selected && !correct && !incorrect) {
            checkmarkSrc = CHECKED_LARGE_SRC;
            checkmarkSrcSet = `${CHECKED_LARGE_2X_SRC} 2x`;
          } else if (correct) {
            checkmarkSrc = CORRECT_SRC;
            checkmarkSrcSet = `${CORRECT_2X_SRC} 2x`;
          } else if (incorrect) {
            checkmarkSrc = MISTAKE_LARGE_SRC;
            checkmarkSrcSet = `${MISTAKE_LARGE_2X_SRC} 2x`;
          }

          return (
            <li
              key={answerId}
              className={cx(s.option, {
                [s.selected]: selected,
                [s.correct]: correct,
                [s.incorrect]: incorrect,
                [s.answeredCorrectly]: selected && correct,
                [s.answeredIncorrectly]: selected && incorrect,
              })}
              onClick={() => !disabled && onChange(answerId)}
              data-test="multi-choice-answer"
            >
              <div className={s.optionWrapper}>
                {checkmarkSrc && (
                  <img
                    className={s.checkmark}
                    src={checkmarkSrc}
                    srcSet={checkmarkSrcSet}
                    alt=""
                    aria-hidden
                    data-test={
                      correct
                        ? 'multi-choice-answer-correct'
                        : incorrect
                        ? 'multi-choice-answer-incorrect'
                        : undefined
                    }
                  />
                )}
                <div className={s.optionLabel}>{optionLabel}</div>
              </div>
              <div className={s.html}>
                <SafeHTML>{answer.get('text')}</SafeHTML>
              </div>
            </li>
          );
        })}
      </ul>

      {selectedAnswerIds?.size > 0 && !isCorrect && (
        <div className={s.incorrectAnswer}>
          <img
            className={s.icon}
            src={MISTAKE_LARGE_SRC}
            srcSet={`${MISTAKE_LARGE_2X_SRC} 2x`}
            alt=""
            aria-hidden
          />
          <p>Incorrect, you didn&lsquo;t select the correct answers.</p>
        </div>
      )}
    </>
  );
};
